import { render, staticRenderFns } from "./AddTestKitV2.vue?vue&type=template&id=50038baf&scoped=true&"
import script from "./AddTestKitV2.vue?vue&type=script&lang=js&"
export * from "./AddTestKitV2.vue?vue&type=script&lang=js&"
import style0 from "./AddTestKitV2.vue?vue&type=style&index=0&id=50038baf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50038baf",
  null
  
)

export default component.exports